import { useState, useEffect } from 'react';

export default function Hero() {
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToConsultation = () => {
    const element = document.getElementById('consultation');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const scrollToDetails = () => {
    const element = document.getElementById('problem');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden">
      {/* Background Image */}
      <div className="absolute inset-0 z-0">
        <img
          src="https://static.readdy.ai/image/138073b6dc82c02f4d68cc5d1eb7657c/1848f382f216542978b933100ccac8cc.png"
          alt="空からの眺め"
          className="w-full h-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/30 to-black/40"></div>
      </div>

      {/* Navigation */}
      <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${isScrolled ? 'bg-white shadow-md' : 'bg-transparent'}`}>
        <div className="max-w-7xl mx-auto px-6 py-4 flex items-center justify-between">
          <div className="flex items-center gap-3">
            <img 
              src="https://public.readdy.ai/ai/img_res/e69c6ee7-e44d-4418-9324-20668ca46385.png" 
              alt="ANA修行サポート" 
              className="h-10 w-auto"
            />
            <span className={`text-lg font-bold transition-colors ${isScrolled ? 'text-[#1A2B4A]' : 'text-white'}`}>
              ANA修行サポート
            </span>
          </div>
          <button
            onClick={scrollToConsultation}
            className={`px-6 py-2.5 rounded-lg font-semibold text-sm whitespace-nowrap transition-all cursor-pointer ${
              isScrolled 
                ? 'bg-[#1A2B4A] text-white hover:bg-[#0D47A1]' 
                : 'bg-white text-[#1A2B4A] hover:bg-gray-100'
            }`}
          >
            無料相談予約
          </button>
        </div>
      </nav>

      {/* Content */}
      <div className="relative z-10 max-w-7xl mx-auto px-6 py-32 grid grid-cols-1 lg:grid-cols-5 gap-12 items-center">
        {/* Left Content */}
        <div className="lg:col-span-3 text-white">
          <div className="inline-block mb-6 px-4 py-2 bg-[#E8EAF6] rounded-full">
            <span className="text-xs font-semibold text-[#0D47A1] tracking-wide">ANAダイヤモンド継続中のげんちゃん監修</span>
          </div>
          
          <h1 className="text-5xl lg:text-6xl font-extrabold leading-tight mb-4">
            修行費用の差は<br />
            ＂設計＂で決まる
          </h1>
          <div className="w-20 h-0.5 bg-[#0D47A1] mb-8"></div>
          
          <p className="text-lg leading-relaxed mb-12 text-gray-100 max-w-2xl">
            相場50〜60万円の世界を、30〜40万円で実現する<br />
            合理的設計による、再現可能なアプローチ。
          </p>
          
          <div className="flex flex-wrap gap-5">
            <a
              href="https://office4c.wixsite.com/my-site-1/booking-calendar/30分無料相談?referral=service_list_widget"
              target="_blank"
              rel="noopener noreferrer"
              className="px-10 py-4 bg-[#0D47A1] text-white rounded-lg font-semibold text-base hover:bg-[#1565C0] transition-colors whitespace-nowrap cursor-pointer"
            >
              30分無料相談を予約する
            </a>
          </div>
        </div>

        {/* Right Visual */}
        <div className="lg:col-span-2 relative">
          <div className="relative rounded-3xl overflow-hidden shadow-2xl">
            <div className="absolute bottom-6 right-6 bg-white rounded-2xl shadow-xl p-6 w-32">
              <div className="text-xs text-gray-600 mb-1 font-medium">年間維持費</div>
              <div className="text-3xl font-extrabold text-[#0D47A1]">約20万円</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
